import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      alignItems: "center",
      alignSelf: "center",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      justifyContent: "center",
      maxWidth: 700,
      padding: theme.spacing(2),
    },
  })
);
